/* eslint-disable */
import React, { useEffect, useContext } from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import Breadcrumb from '../../common/BreadCrumb';
import { ROUTES } from '../../../constants/constants';
import RestartTooltip from './RestartTooltip';
import {
  getSvocId, getUserId, isB2BUser, getHost, getUserEmail
} from '../../../utils/utils';
import { restartVerification } from '../../../api/api';
import { track } from '../../../analytics/analytics';
import { RESTART_APP_LINK } from '../../../constants/analytics';

export const Verification = (props) => {
  const { apiResponse, isSpouse } = props;
  const { channel, isConsumerApp } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  const { verificationId } = apiResponse;
  const crumbs = [ROUTES.home, ROUTES.landing, ROUTES.verification];
  const metadata = {
    svocId: getSvocId(),
    userId: getUserId(),
    pro: isB2BUser(),
    host: getHost(),
    spouse: isSpouse,
  };
  let hostEnv = 'prod';
  let iframeBaseUrl = 'https://offers.sheerid.com/home-depot/military/';
  if (metadata.host.indexOf('qa71') > -1) {
    hostEnv = 'dev';
    iframeBaseUrl = 'https://offers.sheerid.com/home-depot/staging/military/';
  } else if (metadata.host.indexOf('qa74') > -1) {
    hostEnv = 'stage';
    iframeBaseUrl = 'https://offers.sheerid.com/home-depot/staging/military/';
  }

  const redirectUrl = encodeURIComponent(`https://${metadata.host}/military/discount`);
  const params = [
    `svocId=${metadata.svocId}`,
    `userId=${metadata.userId}`,
    `redirect-url=${redirectUrl}`,
    `pro=${metadata.pro}`,
    `env=${hostEnv}`,
    `spouse=${metadata.spouse}`,
  ];
  if (verificationId) {
    params.push(`verificationId=${verificationId}`);
  }
  const iframeUrl = `${iframeBaseUrl}?${params.join('&')}`;

  function sendMessage() {
    const iFrame = document.getElementsByClassName('sid-inline-iframe');
    iFrame[0].contentWindow.postMessage(JSON.stringify({ fields: { email: getUserEmail() } }), '*');
  }

  useEffect(() => {
    function receiveMessage(e) {
      try {
        const response = JSON.parse(e.data);
        if (response.loaded) {
          sendMessage();
        }
      } catch (err) {}
    }
    window.addEventListener('message', receiveMessage);

    const bodyScriptNode = document.createElement('script');
    bodyScriptNode.setAttribute(
      'src',
      'https://cdn.jsdelivr.net/npm/@sheerid/jslib@1.204.0/sheerid.js'
    );
    bodyScriptNode.setAttribute('integrity', 'sha256-6X6TpLtAYxGNPr5NkJM0aK1QM/I+H/8bvkc7fRHSoMQ=');
    bodyScriptNode.setAttribute('crossorigin', 'anonymous');
    bodyScriptNode.onload = () => iframeLoaded();
    document.body.appendChild(bodyScriptNode);

    return () => {
      document.body.removeChild(bodyScriptNode);
      window.removeEventListener('message', receiveMessage);
    };
  }, []);

  const iframeLoaded = () => {
    if (window.sheerId) {
      window.sheerId.loadInlineIframe(document.getElementById('sheerid-container'), iframeUrl);
    }
  };

  const clickRestartLink = async () => {
    await restartVerification();
    track(RESTART_APP_LINK);
    window.location.replace('/military/discount');
  };

  return (
    <div className="container">
      {!isConsumerApp && <Breadcrumb crumbs={crumbs} />}
      <Typography weight="display" variant="h1" uppercase>
        Verification
      </Typography>
      <div id="sheerid-container" />
      <div className={isMobile ? 'restart-link-mobile' : 'restart-link'}>
        <RestartTooltip />
        <span> Having trouble?</span>{' '}
        <span className="list__link" onClick={clickRestartLink}>
          {' '}
          Restart your application.
        </span>{' '}
      </div>
    </div>
  );
};

Verification.propTypes = {};

Verification.displayName = 'VerificationPage';

Verification.defaultProps = {
  name: '',
};
